module.exports = __webpack_public_path__ + "img/bindCard-bg.58b030ba.png";